/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Status_RetiredInputs */

const vi_vehicle_status_retired = /** @type {(inputs: Vehicle_Status_RetiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng sử dụng`)
};

/**

* @param {Vehicle_Status_RetiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_status_retired = /** @type {((inputs?: Vehicle_Status_RetiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Status_RetiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_status_retired(inputs)
});